import React from 'react'
import { FormattedMessage, useIntl } from 'react-intl'

import s from './styles.module.scss'

import { SvgEmail, SvgPhone } from '../icons'

const BookingAssistance = ({ showTitle = true }: { showTitle?: boolean }) => {
  const intl = useIntl()
  return (
    <div className={s.assistance}>
      {showTitle && (
        <div className={s.title}>
          <FormattedMessage
            id='ui.BookingAssistance.Assistance'
            defaultMessage='Assistance'
          />
        </div>
      )}
      <div className={s.phone}>
        <span className={s.icon}>
          <SvgPhone />
        </span>
        <a
          href={intl.formatMessage({
            id: 'ui.phoneNumberHref',
            defaultMessage: 'tel:+33189713394',
          })}
        >
          <FormattedMessage
            id='ui.BookingAssistance.phoneNumber'
            defaultMessage='+33 1 89 71 33 94'
          />
        </a>
      </div>
      <div className={s.email}>
        <span className={s.icon}>
          <SvgEmail />
        </span>
        <a
          href={`mailto:${intl.formatMessage({
            id: 'ui.nabooMail',
            defaultMessage: 'hello@naboo.app',
          })}`}
        >
          <FormattedMessage
            id='ui.nabooMail'
            defaultMessage='hello@naboo.app'
          />
        </a>
      </div>
    </div>
  )
}

export default BookingAssistance
